var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.297 4.934a1.013 1.013 0 0 1 1.344-.078l.088.078L5.254 8.46 12.219.353a1.013 1.013 0 0 1 1.334-.18l.094.072c.394.338.464.914.18 1.334l-.072.094-7.676 8.935a1.013 1.013 0 0 1-1.398.134l-.087-.078L.297 6.367a1.013 1.013 0 0 1 0-1.433Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.7c20fcc118eca7c84073c1b257531bc3.svg";
export { ForwardRef as ReactComponent };